
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/uGame/urps",
      function () {
        return require("private-next-pages/uGame/urps.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/uGame/urps"])
      });
    }
  